import { render, staticRenderFns } from "./ApparelGenderModal.vue?vue&type=template&id=19be2e04&scoped=true&"
import script from "./ApparelGenderModal.vue?vue&type=script&lang=js&"
export * from "./ApparelGenderModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19be2e04",
  null
  
)

export default component.exports